// https://sponda-kohteet.stage.crasman.fi/admin/manage/scriptlets/scriptletmanager/scriptleteditor/html/code/show/lXoeNRSMSOi7RX9s4hfR-Q

import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import { colorClassNames } from 'lib/settings';

const Accessibility = props => {
	const {
		t,
		options,
		building: {
			spaces,
			construction_year,
			renevation_year,
			floors,
			total_area,
			energy_efficiency_program,
			energy_class,
			environment_certificate,
		},
	} = props;

	const backgroundColor = options['background-color'];
	const bgColorClass = backgroundColor in colorClassNames ? colorClassNames[backgroundColor] : '';
	const totalArea = total_area.replace('m2', '').replace('m²', '').trim() + ' m²';

	let componentClass = 'b-component b-building-properties';

	if (bgColorClass) {
		componentClass += ' b-slot-theme-' + bgColorClass;
	}

	const style = {
		backgroundColor,
	};

	const spaceTypes = spaces.map(space => space.type);
	const uniqueSpaceTypes = spaceTypes.filter((type, index) => spaceTypes.findIndex(type2 => type2 === type) === index)
		.filter(v => v !== '');

	const properties = [
		{
			title: 'building/details/Space types',
			value: uniqueSpaceTypes.map(type => t('space-type/' + type)).join(', '),
		},
		{
			title: 'browse/Building/List/Construction year',
			value: construction_year,
		},
		{
			title: 'a11y/Renovation year',
			value: renevation_year,
		},
		{
			title: 'building/details/Floors',
			value: floors
		},
		{
			title: 'building/details/Area',
			value: totalArea
		},
		{
			title: 'a11y/Energy efficiency class',
			value: energy_class,
		},
		{
			title: 'layout/responsibility',
			value: environment_certificate
		},
	].filter(prop => prop.value !== '' && prop.value !== '0');

	return (
		<div className={componentClass} style={style}>
			{properties.map(({ title, value }) => (
				<div key={title} className="b-building-property">
					<h4 dangerouslySetInnerHTML={{__html: t(title) }}></h4>
					<p>{value}</p>
				</div>
			))}
		</div>
	);
}

Accessibility.propTypes = {
	t: PropTypes.func,
	language: PropTypes.oneOf(['fi', 'en']),
	options: PropTypes.object,
	slotActive: PropTypes.bool,
	building: PropTypes.object,
	buildingFieldLocalNames: PropTypes.object,
}

export default translate('translations')(Accessibility);
